import { styled } from "@mui/system";
import React from "react";
import LineChart from "../../Chart/LineChart";
import { BoxUpper } from "../BoxUpper";
import { RawBox } from "components/Shared/Dashboard/styled";
import { toLineChartDataFormat } from "helpers/dataFormat";

const BoxBodyContainer = styled("div")(({ theme }) => ({
  height: "350px",
  display: "grid",
  gridTemplateColumns: "100%",
}));

export const options = [
  { label: "کل سال مالی", value: "" },
  { label: "شش ماهه", value: "lastSixMonth" },
  { label: "ماهانه", value: "lastMonth" },
  { label: "هفتگی", value: "lastWeek" },
];

const LineChartComponent = ({
  title,
  data,
  onSelect,
  selectOption,
}: {
  title?: string;
  data: buyAndSaleDataType;
  onSelect?: (filterType: string) => void;
  selectOption: string;
}) => {
  const lineData = toLineChartDataFormat(data);

  return (
    <RawBox>
      <BoxUpper title={title} options={options} onChange={onSelect} />
      <BoxBodyContainer>
        <LineChart selectOption={selectOption} data={lineData} />
      </BoxBodyContainer>
    </RawBox>
  );
};

export default LineChartComponent;
